import { type SharedData } from '@/types';
import { router } from '@inertiajs/react';
import { useEffect, useState } from 'react';

type ImpersonatingData = SharedData['impersonating'];

function getInitialImpersonating(): ImpersonatingData {
    if (typeof document === 'undefined') {
        return null;
    }

    const pageJson = document.getElementById('app')?.dataset.page;

    if (!pageJson) {
        return null;
    }

    try {
        const parsed = JSON.parse(pageJson) as { props?: SharedData };

        return parsed.props?.impersonating ?? null;
    } catch {
        return null;
    }
}

export function ImpersonationBanner() {
    const [impersonating, setImpersonating] = useState<ImpersonatingData>(() => getInitialImpersonating());

    useEffect(() => {
        const handleNavigate = (event: Event) => {
            const navigateEvent = event as CustomEvent<{ page?: { props?: SharedData } }>;
            setImpersonating(navigateEvent.detail?.page?.props?.impersonating ?? null);
        };

        document.addEventListener('inertia:navigate', handleNavigate as EventListener);

        return () => {
            document.removeEventListener('inertia:navigate', handleNavigate as EventListener);
        };
    }, []);

    if (!impersonating) return null;

    return (
        <div className="fixed top-0 right-0 left-0 z-[70] flex items-center justify-between bg-amber-400 px-4 py-2 text-sm font-medium text-amber-900 shadow-md">
            <span>
                Você está acessando como <strong>{impersonating.user_name}</strong> ({impersonating.user_email})
            </span>
            <button
                onClick={() => router.post('/stop-impersonating')}
                className="ml-4 rounded bg-amber-700 px-3 py-1 text-white transition-colors hover:bg-amber-800"
            >
                Voltar ao painel admin
            </button>
        </div>
    );
}
